/**
 * @class away.base.HitTestCache
 */
var HitTestCache = /** @class */ (function () {
    function HitTestCache() {
        /**
         *
         */
        this.cells = new Array();
        /**
         *
         */
        this.lastCollisionIndex = -1;
    }
    return HitTestCache;
}());
export { HitTestCache };
